import SelectRegion from './SelectRegion';
export default SelectRegion;



// WEBPACK FOOTER //
// ./src/pages/StarterpacksPage/components/SelectRegion/index.ts